import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthorizationRoles } from '#pie/internal/api/pie-bff';
import { StatusTag } from '../status-tag/StatusTag';

export interface StatusTagProps {
  className?: string;
  role: AuthorizationRoles;
}

const AuthMap: Record<
  AuthorizationRoles,
  ComponentProps<typeof StatusTag>['status']
> = {
  [AuthorizationRoles.CprAdmin]: 'update',
  [AuthorizationRoles.CprRead]: 'update',
  [AuthorizationRoles.Tickets]: 'progress',
  [AuthorizationRoles.TicketsMpMp]: 'progress',
  [AuthorizationRoles.KnowledgeArticles]: 'new',
  [AuthorizationRoles.DataRequest]: 'completed',
  [AuthorizationRoles.SimpleDataRequest]: 'completed',
  [AuthorizationRoles.MarketPartyRegistryRead]: 'attention',
  [AuthorizationRoles.MarketPartyRegistryReadAll]: 'attention',
  [AuthorizationRoles.SuperUser]: 'completed',
};

export function AuthorizationTag({ className, role }: StatusTagProps) {
  const { t } = useTranslation();

  return (
    <StatusTag status={AuthMap[role]} className={className}>
      {t(`common.roles.${role}`)}
    </StatusTag>
  );
}
